var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconForward10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"forward 10 seconds\""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.1187 5.94436L16.0006 2.05469",
    stroke: "white",
    strokeWidth: 2.34791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.6139 25.6128C26.362 30.3056 21.5589 33.5497 15.9999 33.5497C8.26767 33.5497 2 27.282 2 19.5498C2 11.8176 8.26767 5.54993 15.9999 5.54993C17.0707 5.54993 18.1101 5.69174 19.118 5.92795",
    stroke: "white",
    strokeWidth: 2.34791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.1658 11.1885C28.9138 13.5192 30.0005 16.4009 30.0005 19.5505",
    stroke: "#4AC97D",
    strokeWidth: 2.34791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.1259 23.9757V15.5665L9.76367 18.1964",
    stroke: "white",
    strokeWidth: 2.34791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.1502 15.5665C20.8824 15.5665 22.2998 16.9838 22.2998 18.7161V20.8421C22.2998 22.5743 20.8824 23.9916 19.1502 23.9916C17.4179 23.9916 16.0006 22.5743 16.0006 20.8421V18.7161C16.0006 16.9681 17.4179 15.5665 19.1502 15.5665Z",
    stroke: "white",
    strokeWidth: 2.34791,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForward10);
export default __webpack_public_path__ + "static/media/icon_forward_10.25d6ac2d36c72b0ad3e57c7cb6f4deb8.svg";
export { ForwardRef as ReactComponent };